module.exports = __webpack_public_path__ + "static/v-for-vendetta-0e5ded98edcf9a8924475f6ca906d9a7.jpg";